import { UserForm } from "./user.form";
import { UserModel } from "./user.model";
import { UserStore } from "./user.store";
import { useService } from "@policoders/di";
import {
  BreadcrumbService,
  CellType,
  TColumn,
  TTableActions,
  TTableLineActions,
} from "@policoders/ds";
import { useEffect, useState } from "react";

export const useUser = () => {
  const store = useService<UserStore>("UserStore");
  const [lines, setLines] = useState<UserModel[]>([]);

  const breadcrumb = useService<BreadcrumbService>("BreadcrumbService");
  useEffect(() => {
    breadcrumb.set([
      { label: "Administração", value: "/administration" },
      { label: "Usuários", value: "/administration/users" },
    ]);
  }, [breadcrumb]);

  useEffect(() => {
    store.loadList();
    var subscriber = store.state$.subscribe(state => {
      state.users &&
        setLines(
          state.users.map(user => ({
            ...user,
            nameActive: user.active ? user.name : `${user.name} (inativo)`,
            su: user.superUser
              ? { type: "danger", value: "super" }
              : { type: "dark", value: "user" },
          })),
        );
    });
    return () => {
      subscriber.unsubscribe();
    };
  }, [store]);

  const handleSave = async () => {
    store.save();
  };

  const handleNew = () => {
    const model = new UserModel();
    store.updateCurrent(model);
    store.ui.modal
      .config({
        title: "novo usuário",
        size: "large",
        buttonOkLabel: "Criar",
        buttonOkAction: handleSave,
        children: () => (
          <UserForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const handleEdit = (line: UserModel) => {
    const model = lines.find(x => x.id === line.id);
    if (!model) return;
    store.ui.modal
      .config({
        title: `editar usuário (${line.id.split("-")[0]})`,
        size: "large",
        buttonOkLabel: "Salvar",
        buttonOkAction: handleSave,
        children: () => (
          <UserForm
            data={model}
            onChange={state => {
              store.updateCurrent(state);
            }}
          />
        ),
      })
      .open();
  };

  const handleInactivate = (line: UserModel) => {
    if (window.confirm("alterar status do usuário?")) store.toggleActive(line.id);
  };

  const tActions: TTableLineActions[] = [{ label: "ativar/desativar", onClick: handleInactivate }];

  const tColumns: TColumn[] = [
    { field: "su", title: "#", type: CellType.BADGE },
    { field: "nameActive", title: "Nome" },
    { field: "email", title: "E-Mail", columnClass: "d-none d-md-table-cell" },
    { field: "cellphone", title: "Celular" },
    { field: "telephone", title: "Telefone", columnClass: "d-none d-md-table-cell" },
  ];

  const tHeaderButtons: TTableActions = {
    buttonNew: {
      label: "Novo",
      action: handleNew,
    },
  };

  return {
    lines,
    tActions,
    tColumns,
    tHeaderButtons,
    handleEdit,
  };
};
